import { DashboardActionTypes, DashboardState } from './dashboard.types';

export const GET_CALENDAR_EVENTS: DashboardActionTypes = 'GET_CALENDAR_EVENTS';
export const DELETE_CALENDAR_EVENT: DashboardActionTypes = 'DELETE_CALENDAR_EVENT';
export const CREATE_CALENDAR_EVENT: DashboardActionTypes = 'CREATE_CALENDAR_EVENT';
export const UPDATE_CALENDAR_EVENT: DashboardActionTypes = 'UPDATE_CALENDAR_EVENT';

export const GET_ABSENT_MEMBERS: DashboardActionTypes = 'GET_ABSENT_MEMBERS';
export const GET_EXPIRING_MEMBERS: DashboardActionTypes = 'GET_EXPIRING_MEMBERS';

export const initialDashboardState: DashboardState = {
  statusCode: 0,
  dashboardCalendarEvents: [],
  expiringMembersStatus: 0,
  expiringMembers: [],
  absentMembersStatus: 0,
  absentMembers: []
};


// WEBPACK FOOTER //
// ./src/dashboard/dashboard.constants.tsx